import { render, staticRenderFns } from "./main-photo.vue?vue&type=template&id=6cbd1544&scoped=true&"
import script from "./main-photo.vue?vue&type=script&lang=js&"
export * from "./main-photo.vue?vue&type=script&lang=js&"
import style0 from "./main-photo.vue?vue&type=style&index=0&id=6cbd1544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd1544",
  null
  
)

export default component.exports